import { createFileRoute, Outlet } from '@tanstack/react-router';

import { Sorry } from '@/features/registration';

export const Route = createFileRoute('/$hci_shortname')({
	component: () => <Outlet />,
	notFoundComponent: () => <Sorry />,
});
